import psHttp from '@patsnap/common-ps-http';
import { coreSearchApiUrlPrefix, coreBasicApiUrlPrefix } from '../../config/constants';

export function helperSearchApi({
    q,
    type,
    start
}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/classification/helper-search`,
        method: 'GET',
        params: {
            q,
            type,
            start
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function helperSectionApi({ type }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/classification/helper-section`,
        method: 'GET',
        params: {
            type
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function helperSubClassApi ({
    type,
    code,
    level,
    start = 0
}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/classification/helper-subclass`,
        method: 'GET',
        params: {
            type,
            code,
            level,
            start
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getCategoryDetailApi(type, name) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/classification/detail?type=${type}&cid=${name}`,
        method: 'GET',
        transformCode: true
    });
}

//分类号助手
export const getClassificationVersion = () => {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/config/classification-latest-version`,
        method: 'GET',
        transformCode: true,
    });
};
